<div class="imageCont">
  @if (logo) {
    <img src="{{ logo }}" />
  } @else {
    <span class="defaultLogo"></span>
  }

</div>
